import { useEffect, useState } from "react";
import router from "next/router";
import Button from "@/admin/atoms/Button";
import LandingPageNavArea from "../LandingPageComponents/LandingPageNavArea";
import AdminOnboardingBottomArea from "../AdminOnboardingBottomArea";
import styles from "./AboutUsAdminBackground.module.css";

function AboutUsAdminBackground(): JSX.Element {
  const [isMobile, setIsMobile] = useState(false);

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 768);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div className={styles.frame}>
      <LandingPageNavArea showDesktopMenu />
      <div className="w-full h-[212px] phone:h-[143px] bg-[#4856DD] flex flex-col justify-center items-center">
        <div className="w-full text-center text-[30px] phone:text-[20px] text-white font-bold">
          About Us
        </div>
        <div className="w-full text-center text-[18px] phone:text-[14px] text-white">
          Transforming Learning, One Organization at a Time
        </div>
      </div>

      <div className="w-full phone:mt-10 ">
        <div className={styles.secondLayerFrame}>
          <div className="w-full text-[#4856DD] text-[18px]">WHO WE ARE</div>
          <div className="w-full flex justify-between phone:flex-col">
            <div className="w-[60%] phone:w-full text-[48px] phone:text-[32px] leading-[120%] font-bold">
              We’re on a Mission to Simplify Learning Experiences
            </div>
            <div className="w-[40%] mt-4  phone:w-full text-[16px] phone:text-[14px] leading-[135%] text-[#555555]">
              We are digital architects reshaping learning by helping
              organizations transform learning into unforgettable experiences.
              We blend innovation with simplicity to unlock the full potential
              of your training programmes no matter the size of your
              organization.
            </div>
          </div>
          <div className="w-full h-[486px] phone:h-auto  mt-10 relative">
            <img
              src={
                isMobile
                  ? "/images/about-us-image1Mobile.svg"
                  : "/images/about-us-image1.svg"
              }
              alt="about us"
              className="w-full h-[486px] phone:h-[194px]  object-cover "
            />
          </div>

          <div className="w-full text-[#4856DD] text-[18px] mt-[148px] phone:mt-10">
            OUR VALUES
          </div>
          <div className="text-[#262626] text-[40px] phone:text-[32px] leading-[110%] mt-4">
            The Principles That Drive Our Commitment to Excellence
          </div>

          <div className="text-[#555555] text-[18px] leading-[135%] mt-2">
            These values define who we are and guide our mission to create
            impactful learning solutions. They inspire trust, innovation, and a
            shared passion for delivering value to training organizations
            worldwide.
          </div>

          <div className="w-full flex gap-x-20 phone:gap-x-5 phone:gap-y-6 mt-10 phone:flex-col">
            <div className="w-1/2 h-[192px] phone:h-auto phone:w-full flex gap-x-8 phone:gap-x-2 phone:flex-col phone:gap-y-2 phone:px-4 border p-6 border-[#1A1A1A0D] rounded-lg shadow-lg ">
              <img
                src="/icons/about-us/innovation.svg"
                width={isMobile ? 64 : 128}
                height={isMobile ? 64 : 128}
                alt="innovation"
              />
              <div className="flex flex-col gap-y-4 phone:gap-y-2">
                <div className="text-[20px] font-medium text-[#262626] leading-[135%] mt-2 ">
                  INNOVATION WITH PURPOSE
                </div>
                <div className="text-[16px] phone:text-[14px] text-[#555555] leading-[135%]">
                  Continuously delivering modern solutions that simplify
                  learning management.
                </div>
              </div>
            </div>
            <div className="w-1/2 h-[192px] phone:h-auto phone:flex-col phone:gap-y-2 phone:w-full  flex gap-x-8 phone:gap-x-2 phone:px-4 border p-6 border-[#1A1A1A0D] rounded-lg shadow-lg ">
              <img
                src="/icons/about-us/scalability.svg"
                width={isMobile ? 64 : 128}
                height={isMobile ? 64 : 128}
                alt="scalability"
              />
              <div className="flex flex-col gap-y-4 phone:gap-y-2">
                <div className="text-[20px] font-medium text-[#262626]leading-[135%] mt-2">
                  SCALABILITY & FLEXIBILITY
                </div>
                <div className="text-[16px] phone:text-[14px] text-[#555555] leading-[135%]">
                  Adapting to meet the unique needs of every training
                  organization, big or small.
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex gap-x-20 mt-10  phone:gap-x-5 phone:gap-y-6 phone:flex-col">
            <div className="w-1/2 phone:w-full h-[192px] phone:h-auto phone:flex-col phone:gap-y-2  flex gap-x-8 phone:gap-x-2 phone:px-4 border p-6 border-[#1A1A1A0D] rounded-lg shadow-lg ">
              <img
                src="/icons/about-us/collaboration.svg"
                width={isMobile ? 64 : 128}
                height={isMobile ? 64 : 128}
                alt="collaboration"
              />
              <div className="flex flex-col gap-y-4 phone:gap-y-2">
                <div className="text-[20px] font-medium text-[#262626] leading-[135%] mt-2">
                  COLLABORATION & TRUST
                </div>
                <div className="text-[16px] phone:text-[14px] text-[#555555] leading-[135%]">
                  Building strong, lasting partnerships through transparency and
                  teamwork.
                </div>
              </div>
            </div>
            <div className="w-1/2 phone:w-full h-[192px]  phone:h-auto phone:flex-col phone:gap-y-2 flex gap-x-8 phone:gap-x-2 phone:px-4 border p-6 border-[#1A1A1A0D]  rounded-lg shadow-lg ">
              <img
                src="/icons/about-us/security.svg"
                width={isMobile ? 64 : 128}
                height={isMobile ? 64 : 128}
                alt="security"
              />
              <div className="flex flex-col gap-y-4 phone:gap-y-2">
                <div className="text-[20px] font-medium text-[#262626] leading-[135%] mt-2">
                  SECURITY & COMPLIANCE
                </div>
                <div className="text-[16px] phone:text-[14px] text-[#555555] leading-[135%]">
                  Committed to data protection and global standards.
                </div>
              </div>
            </div>
          </div>

          <div className="w-full h-[659px] phone:h-auto flex gap-x-20 mt-[148px] phone:mt-16">
            <div className="w-1/2 phone:w-full flex flex-col ">
              <div className="w-full text-[#4856DD] text-[18px] phone:text-[16px]">
                WHY BUSINESSES CHOOSE US
              </div>
              <div className="text-[40px] font-medium phone:text-[32px] leading-[110%] mt-2 text-[#262626]">
                The Smarter Choice for Effective Training Management
              </div>
              <div className="text-[18px] phone:text-[14px] leading-[135%] phone:mt-4 text-[#555555] ">
                We understand that every business is unique and so is its
                learning journey. Trusted by{" "}
                <span className="text-[#4856DD] font-bold">1000+</span> number
                of organizations globally, MyEdvault is trusted for:
              </div>

              <div className="w-full h-[659px] flex flex-col phone:gap-y-5 justify-between phone:justify-start phone:h-auto mt-6">
                <div className="w-full h-[80px]  flex items-center gap-x-2 border py-4 px-6 border-[#1A1A1A0D]  rounded-lg shadow-lg ">
                  <img
                    src="/icons/about-us/Star11.svg"
                    width={32}
                    height={32}
                    alt="star1"
                  />
                  <div className="font-medium text-[#555555]">
                    SIMPLICITY THAT WORKS
                  </div>
                </div>

                <div className="w-full h-[80px]  flex items-center gap-x-2 border py-4 px-6 border-[#1A1A1A0D]  rounded-lg shadow-lg ">
                  <img
                    src="/icons/about-us/Star11.svg"
                    width={32}
                    height={32}
                    alt="star2"
                  />
                  <div className="font-medium text-[#555555]">
                    SUPPORT THAT CARES
                  </div>
                </div>

                <div className="w-full h-[80px]  flex items-center gap-x-2 border py-4 px-6 border-[#1A1A1A0D]  rounded-lg shadow-lg ">
                  <img
                    src="/icons/about-us/Star11.svg"
                    width={32}
                    height={32}
                    alt="star2"
                  />
                  <div className="font-medium text-[#555555]">
                    FLEXIBILITY THAT FITS
                  </div>
                </div>

                <div className="w-full h-[80px]  flex items-center gap-x-2 border py-4 px-6 border-[#1A1A1A0D] rounded-lg  shadow-lg  ">
                  <img
                    src="/icons/about-us/Star11.svg"
                    width={32}
                    height={32}
                    alt="star"
                  />
                  <div className="font-medium text-[#555555]">
                    ENGAGEMENT THAT LAST
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/2 relative phone:w-0 phone:hidden ">
              <img
                src="/icons/about-us/tabImage.svg"
                className="w-full h-[659px] rounded-lg object-cover "
                alt="tab"
              />
            </div>
          </div>
          {/* 
          <div className="w-full h-[224px] phone:h-auto flex items-center phone:border-none mt-[148px] phone:mt-16 border-t border-b border-[#C2C2C2]">
            <div className="w-full h-[111px] flex phone:h-auto phone:flex-col justify-center items-center ">
              <div className="w-[25%] h-full phone:h-auto  p-2 flex phone:flex-col justify-center items-center gap-x-6 ">
                <img
                  src="/icons/about-us/flash.svg"
                  alt=""
                  width={isMobile ? 48 : 64}
                  height={isMobile ? 48 : 64}
                />
                <div className="flex flex-col phone:-mt-4 h-full ">
                  <div className="font-bold text-[60px] h-[70%] phone:h-auto  phone:auto ">
                    2k
                  </div>
                  <div className="h-[30%] phone:h-auto phone:-mt-6">
                    Organization
                  </div>
                </div>
              </div>
              <div className="w-[25%] h-full  p-2 phone:mt-4 flex phone:flex-col phone:border-none items-center gap-x-6 justify-center  border-x border-[#C2C2C2]">
                <img
                  src="/icons/about-us/note.svg"
                  alt=""
                  width={isMobile ? 48 : 64}
                  height={isMobile ? 48 : 64}
                />
                <div className="flex flex-col phone:-mt-4 h-full ">
                  <div className="font-bold text-[60px] h-[70%]  ">4</div>
                  <div className="h-[30%] phone:h-auto phone:-mt-6">
                    Features
                  </div>
                </div>
              </div>
              <div className="w-[25%] phone:mt-4 h-full p-2 flex phone:flex-col phone:border-none items-center gap-x-6 justify-center   border-r border-[#C2C2C2]">
                <img
                  src="/icons/about-us/global.svg"
                  alt=""
                  width={isMobile ? 48 : 64}
                  height={isMobile ? 48 : 64}
                />
                <div className="flex flex-col phone:-mt-4 h-full ">
                  <div className="font-bold text-[60px] h-[70%] ">14</div>
                  <div className="h-[30%] phone:h-auto phone:-mt-6">
                    Countries
                  </div>
                </div>
              </div>

              <div className="w-[25%] h-full phone:mt-4  p-2 phone:flex-col  gap-x-6 flex items-center justify-center ">
                <img
                  src="/icons/about-us/people.svg"
                  alt=""
                  width={isMobile ? 48 : 64}
                  height={isMobile ? 48 : 64}
                />
                <div className="flex flex-col  phone:-mt-4 h-full ">
                  <div className="font-bold text-[60px] h-[70%] ">6</div>
                  <div className="h-[30%] phone:h-auto phone:-mt-6">
                    Partners
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="w-full h-[388px] phone:h-auto phone:mt-10 p-10 phone:px-6 mt-20 flex flex-col justify-center  items-center rounded-3xl bg-[#EDEEFC52]">
            <div className="w-[60%] phone:w-full text-[32px] leading-[135%] text-[#262626] text-center">
              Discover the Difference{" "}
              <span className="text-[#EE2A7B] italic">MyEdVault</span> Brings to
              Your Learning Ecosystem
            </div>
            <div className="w-[70%] phone:w-full mt-6 text-center leading-[135%]">
              Take your training programs to the next level by partnering in
              this learning evolution. Schedule a personalized demo or sign up
              today and experience streamlined training management like never
              before!
            </div>
            <div className="w-[70%] phone:w-full mt-10 flex items-center justify-center gap-x-8">
              <Button
                width="auto"
                variant="landing-primary"
                onClick={() => {
                  router.push("/sign-up");
                }}
              >
                <p className="w-full  py-4 px-5 phone:px-2.5">Sign up</p>
              </Button>
              <Button
                width="auto"
                variant="landing-secondary"
                onClick={() => {
                  router.push("/admin-portal/onboarding/contact-us");
                }}
              >
                <p className="w-full  p-4 phone:px-1">Contact Us</p>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <AdminOnboardingBottomArea />
    </div>
  );
}

export default AboutUsAdminBackground;
